import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getCurrentEnvironment } from "../utils/environment";

const EnvironmentBanner = () => {
  const { t } = useTranslation();
  const env = getCurrentEnvironment();

  if (env === "production") return null;

  const bgColor: { [key: string]: string } = {
    development: "#3b82f6",
    test: "#eab308",
  };

  const text = env === "test" ? t("envBanner.test") : t("envBanner.development");
  const bg = bgColor[env] || bgColor.development;

  return (
    <Box
      sx={{
        backgroundColor: bg,
        color: "white",
        textAlign: "center",
        py: 0.5,
        fontSize: "0.875rem",
        fontWeight: 600,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {text}
      </Typography>
    </Box>
  );
};

export default EnvironmentBanner;
